import { IWPImage } from "@/src/types";
import React from "react";
import S from "./SubHero.styled";
import { getImage } from "gatsby-plugin-image";

export interface Props {
  preTitle: string;
  title: string;
  text: string;
  backgroundImage: IWPImage;
  children?: React.ReactNode;
}

const SubHero: React.FC<Props> = ({
  preTitle,
  title,
  text,
  backgroundImage,
  children,
}) => {
  // create gatsby-image-data
  const backgroundImageData = backgroundImage?.localFile?.childImageSharp
    ?.gatsbyImageData
    ? getImage(backgroundImage.localFile.childImageSharp.gatsbyImageData)
    : null;

  return (
    <S.SubHeroContainer>
      <div className="absolute inset-0 bg-gray-700 opacity-75 z-10"></div>
      {backgroundImageData && (
        <S.BackgroundImage
          image={backgroundImageData}
          alt={backgroundImage.altText || ""}
          className="object-center object-cover pointer-events-none"
        />
      )}

      <div className="md:mx-auto md:max-w-7xl py-12 pb-0 relative block text-center text-white z-10">
        <div
          className="max-w-lg flex-1 z-10 sm:px-2 px-9 pb-14"
          style={{ margin: "0 auto" }}
        >
          <h4 className="text-mGray-500 mt-0">{preTitle && preTitle}</h4>
          <h1 className="text-xl sm:text-3xl md:text-4xl tracking-tight font-extrabold text-white ">
            {title && title}
          </h1>
          {text && <div dangerouslySetInnerHTML={{ __html: text ?? "" }}></div>}
          {children && (
            <div className="mt-5 sm:mt-8 sm:flex justify-center">
              {children}
            </div>
          )}
        </div>
      </div>
    </S.SubHeroContainer>
  );
};

export default SubHero;
